<div
  *ngIf="type === 'removable'"
  class="selected-option {{ color }} {{ type }}"
>
  <div class="text">{{ text }}</div>
  <button *ngIf="!disabled" mat-mini-fab class="btn" (click)="removeOption()">
    <svg-icon
      src="assets/svg/x.svg"
      viewbox="auto"
      svgClass="lightGreen"
    ></svg-icon>
  </button>
</div>

<button
  mat-button
  *ngIf="type === 'clickable'"
  class="selected-option {{ color }} {{ type }}"
  [disabled]="disabled"
  (click)="clickOption()"
>
  {{ text }}
</button>
